import { TimesLight } from '@archipro-design/icons';
import React from 'react';
import * as S from './MultiInputPills.style';
import { useStyles } from '@archipro-design/aria';

interface MultiInputPillsProp {
    inputs: string[];
    onRemove: (input: string) => void;
}

//todo replace once multi-input pills are available from aria
export const MultiInputPills = ({ inputs, onRemove }: MultiInputPillsProp) => {
    const { css } = useStyles();
    const inputPills = inputs?.map((input, index) => {
        return (
            <div key={index} className={css(S.Pill)}>
                {input}
                <TimesLight
                    className={css(S.PillRemove)}
                    onClick={() => onRemove(input)}
                />
            </div>
        );
    });

    return <div className={css(S.PillContainer)}>{inputPills}</div>;
};
